// extracted by mini-css-extract-plugin
module.exports = {"capacityDisplay":"SliderDisplay_capacityDisplay__1atAi","costTooltip":"SliderDisplay_costTooltip__1PAeX","costTooltiptext":"SliderDisplay_costTooltiptext__mWrry"};